import TextField from '@common_forms/TextField';

const OrderCommentView = (props) => {
    const {
        t,
        formik,
    } = props;
    return (
        <>
            <div className="flex flex-col w-full">
                <div className="flex flex-row items-center my-3 w-full">
                    <TextField
                        name="orderComment"
                        onChange={formik.handleChange}
                        value={formik.values.orderComment}
                        placeholder={t('checkout:orderNote')}
                        label={t('checkout:orderNote')}
                        classWrapper="w-full"
                        className="w-full"
                        inputProps={{
                            className: 'w-full!',
                        }}
                        multiline
                        row="4"
                        hintProps={{
                            displayHintText: !!(formik.touched.orderComment && formik.errors.orderComment),
                            hintType: 'error',
                            hintText: formik.errors.orderComment,
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default OrderCommentView;
